// assets
import {
  DashboardOutlined,
  CarOutlined,
  TagsOutlined,
  AppstoreOutlined,
  UserOutlined,
  BookOutlined,
  SafetyOutlined,
  AlertOutlined,
  CommentOutlined,
  EnvironmentOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  CarOutlined,
  TagsOutlined,
  AppstoreOutlined,
  UserOutlined,
  BookOutlined,
  SafetyOutlined,
  AlertOutlined,
  CommentOutlined,
  EnvironmentOutlined,
  PlusCircleOutlined
};

// ==============================|| MENU ITEMS - SIDEBAR SECTIONS ||============================== //
// Grouped into sections so the three "vehicle" areas no longer read as one confusing block:
//  - Operations  -> "Owner Cars" (owner-submitted cars awaiting review/approval)
//  - Catalog     -> "Car Brands" / "Car Models" (reference master data used in dropdowns)

export const overview = {
  id: 'group-overview',
  title: 'Overview',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    }
  ]
};

export const operations = {
  id: 'group-operations',
  title: 'Operations',
  type: 'group',
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.UserOutlined,
      breadcrumbs: true
    },
    {
      // Owner-submitted cars (the approval queue) — distinct from the Catalog master data.
      id: 'owner-cars',
      title: 'Owner Cars',
      type: 'item',
      url: '/vehicles',
      icon: icons.CarOutlined,
      breadcrumbs: true
    },
    {
      id: 'bookings',
      title: 'Bookings',
      type: 'item',
      url: '/bookings',
      icon: icons.BookOutlined,
      breadcrumbs: true
    },
    {
      id: 'incidents-management',
      title: 'Incidents',
      type: 'item',
      url: '/incidents/manage',
      icon: icons.AlertOutlined,
      breadcrumbs: true
    },
    {
      id: 'feedback',
      title: 'Feedback',
      type: 'item',
      url: '/feedback',
      icon: icons.CommentOutlined,
      breadcrumbs: true
    }
  ]
};

export const catalog = {
  id: 'group-catalog',
  title: 'Catalog',
  type: 'group',
  children: [
    {
      id: 'vehicle-brand',
      title: 'Car Brands',
      type: 'item',
      url: '/vehicle/brands',
      icon: icons.TagsOutlined,
      breadcrumbs: true
    },
    {
      id: 'vehicle-model',
      title: 'Car Models',
      type: 'item',
      url: '/vehicle/models',
      icon: icons.AppstoreOutlined,
      breadcrumbs: true
    }
  ]
};

export const plans = {
  id: 'group-plans',
  title: 'Insurance & Plans',
  type: 'group',
  children: [
    {
      id: 'vendor-insurance',
      title: 'Vendor Plans',
      type: 'item',
      url: '/insurance/vendor-plans',
      icon: icons.SafetyOutlined,
      breadcrumbs: true
    },
    {
      id: 'vendor-insurance-purchase',
      title: 'Purchase Insurance',
      type: 'item',
      url: '/insurance/vendor-subscribe',
      icon: icons.SafetyOutlined,
      breadcrumbs: true
    },
    {
      id: 'customer-insurance',
      title: 'Customer Plans',
      type: 'item',
      url: '/insurance/customer-plans',
      icon: icons.SafetyOutlined,
      breadcrumbs: true
    }
  ]
};

export const tools = {
  id: 'group-tools',
  title: 'Tools',
  type: 'group',
  children: [
    {
      id: 'gps-management',
      title: 'GPS Management',
      type: 'item',
      url: '/gps/manage',
      icon: icons.EnvironmentOutlined,
      breadcrumbs: true
    },
    {
      id: 'create-sample-booking',
      title: 'Create Sample Booking',
      type: 'item',
      url: '/bookings/create',
      icon: icons.PlusCircleOutlined,
      breadcrumbs: true
    }
  ]
};

// Backward-compatible default (kept so any existing import of the default still resolves).
const dashboard = overview;
export default dashboard;
